import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { TextLink } from './textLink.component';
import { ContentRegistryActions } from '../../../../modules/contentRegistry';
import { selectExperiences } from '../../../../modules/contentRegistry/contentRegistry.selectors';

const mapStateToProps = createStructuredSelector({
  experiences: selectExperiences,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchExperience: ContentRegistryActions.fetchExperienceById,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(TextLink);
